var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBrandy = function SvgIconBrandy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.243 3.205a1 1 0 0 1 .838-.455H18.92a1 1 0 0 1 .838.455A9.25 9.25 0 0 1 13 17.44V20h2.75a1 1 0 1 1 0 2h-7.5a1 1 0 1 1 0-2H11v-2.56a9.25 9.25 0 0 1-8.25-9.187v-.004a9.27 9.27 0 0 1 1.493-5.044M4.82 9.25a7.25 7.25 0 0 0 14.36 0zm14.362-2H4.818a7.3 7.3 0 0 1 .83-2.5h12.705c.426.776.707 1.624.829 2.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconBrandy;